import { Box, Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { FC } from "react";
import { useHistory } from "react-router-dom";
import { openRedirect$ } from "src/App";
import { DEFAULT_PROJETO } from "src/components/projetos/constants";
import { FlatButton } from "src/framework/components/buttons/FlatButton";
import { useObservable } from "src/framework/store/storeUtil";
import { formState$, onConflictAction$ } from "src/store/vendas/projetos/store";

interface ModalRedirectParams {
    open: boolean;
}

export const ModalRedirect: FC<ModalRedirectParams> = ({ open }) => {
    const history = useHistory()
    const openRedirectPayload = useObservable(openRedirect$);

    return (
        <Dialog
            open={open}
            maxWidth='md'
        >
            <DialogContent>
                <Grid container spacing={1}>
                    <Grid container size={12}>
                        <Grid size={12}>
                            <Box component={"h2"}>Atenção!</Box>
                            <Box component={"p"} style={{fontSize: "16px"}}>{openRedirectPayload?.message || 'Este projeto já foi encaminhado para pagamento. Alterações não são permitidas neste estágio.'}</Box>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <FlatButton
                    color="primary"
                    variant="contained"
                    text="Voltar para a listagem"
                    onClick={()=>{
                        history.replace('/projetos/menu-projetos', { done: true })
                        formState$.next(DEFAULT_PROJETO);
                        openRedirect$.next({ status: false, message: "" });

                        if (onConflictAction$.value && typeof onConflictAction$.value === 'function') {
                            onConflictAction$.value()
                        }

                        onConflictAction$.next(null)
                    }}
                />
            </DialogActions>
        </Dialog>
    )
}

